
// import { actionTypes } from "./actions";
import { getFnstrListAPI,getFnstrALLExportAPI } from './endpoints';
import { actions } from 'store/Reducer/actions';

export const actionTypes = {
    FNSTR_GET_REQUEST: "FNSTR_GET_REQUEST",
    FNSTR_GET_RECEIVE: "FNSTR_GET_RECEIVE",
    FNSTR_GET_FAIL: "FNSTR_GET_FAIL",
    FNSTR_EXPORT_ALL_LOAD: "FNSTR_EXPORT_ALL_LOAD",
    FNSTR_EXPORT_ALL_RECEIVE: "FNSTR_EXPORT_ALL_RECEIVE",
    FNSTR_EXPORT_ALL_FAIL: "FNSTR_EXPORT_ALL_FAIL"
  };

const requestFnstr = () => ({
    type: actionTypes.FNSTR_GET_REQUEST,
});
const receivetFnstr = (payload) => ({
    type: actionTypes.FNSTR_GET_RECEIVE,
    payload,
});
const failuretFnstr = (payload) => ({
    type: actionTypes.FNSTR_GET_FAIL,
    payload,
});

const requestExportAllFnstr= () => ({
    type: actionTypes.FNSTR_EXPORT_ALL_LOAD,
});

const receiveExportAllFnstr = (payload) => ({
    type: actionTypes.FNSTR_EXPORT_ALL_RECEIVE,
    payload,
});
const failureExportAllFnstr = (payload) => ({
    type: actionTypes.FNSTR_EXPORT_ALL_FAIL,
    payload,
});



export const gettFnstrAction = (payload) => {
    return async (dispatch) => {
        dispatch(requestFnstr());
        try {
            const response = await getFnstrListAPI(payload);
            if (response?.status === 200) {
                dispatch(receivetFnstr(response?.data?.data));
                // dispatch(actions.successAlert("Coutries fetched successfully"));
            }
        } catch (error) {
            dispatch(failuretFnstr(error?.response?.data?.data));
            if (error?.response) {
                dispatch(actions.errorAlert(error?.response?.data?.errorMessage));
            } else {
                 dispatch(actions.errorAlert( "Something went wrong, please contact administrator"));
            }
        }
    };
};

export const getFnstrALLExportAction = (payload) => {   
    return async (dispatch) => {
        dispatch(requestExportAllFnstr());
        try {
            const response = await getFnstrALLExportAPI(payload);
            if (response?.status === 200) {
                let a = document.createElement('a');
                a.href = response?.data?.data;
                document.body.appendChild(a);
                // a.target='_blank';
                //a.download = true;
                //a.setAttribute('download','')
                a.click();           
                a.remove();
               dispatch(receiveExportAllFnstr(response?.data));
            }
        } catch (error) {
            dispatch(failureExportAllFnstr(error?.response?.data?.data));
            if (error?.response) {
                dispatch(actions.errorAlert(error?.response?.data?.errorMessage));
            } else {
                 dispatch(actions.errorAlert( "Something went wrong, please contact administrator"));
            }
        }
    };
};

